export default __webpack_public_path__ + "static/media/markuss.81d9c236.webp";